import { isNutritionUiVisible } from './appConfig';

/** When false (`is_nutrition_ui_visible`), hide macro bars, calendar macros, item macro chips. */
export function isNutritionUiEnabled(): boolean {
  return isNutritionUiVisible();
}
